<template>
<ScreenLayout :rightVisible="false">

<div slot="left">
    <v-list subheader>
        <v-subheader>Charts</v-subheader>
        <v-list-item
        v-for="chart in charts"
        :key="chart.title"
       
        @click="activeChart = chart"
        :class="{'active-list-item': isChartActive(chart) }" 
        >
        <v-list-item-avatar>
            <v-icon>mdi-chart-bar</v-icon>
        </v-list-item-avatar>

        <v-list-item-content>
            <v-list-item-title v-html="chart.name"></v-list-item-title>
        </v-list-item-content>

        </v-list-item>
    </v-list>
</div>

<div style="height:100%;overflow:auto;">
    <component :is="activeChart.type" :chart="activeChart" :tenantKey="tenantKey"/>
</div>


</ScreenLayout>

</template>

<script>
import ProgressChart from './ProgressChart'
import VolumeChart from './VolumeChart'
import RangeChart from './RangeChart'
import UpcomingChart from './UpcomingChart'
import AlertHelpers from '../../helpers/AlertHelpers'
import ScreenLayout from '@/screens/ScreenLayout'


export default {
name: 'ProgressRotator',
components: {ProgressChart, VolumeChart, RangeChart, UpcomingChart, ScreenLayout},
props: {
    tenantKey: String,
},
data() {
return {
    seconds: 30,
    activeChart: {},
    charts: [
    {
        name: 'Todays Finance and Settlements',
        type: 'UpcomingChart',
        dates: [
            {
                name: 'finance_date',
                title: 'Finance Date',
                color: '#FF80AB'
            },
            {
                name: 'settlement_date',
                title: 'Settlement Date',
                color: '#9575CD'
            },
        ]
    },
    {
        name: 'Monthly Overview',
        type: 'VolumeChart',
    },
    {
        name: 'Monthly Reports',
        type: 'RangeChart',
    },
    {
        name: 'Lead Tracking',
        triggerStart: 'lead_taken',
        type: 'ProgressChart',
        columns: [
            {
                name: 'clients',
                title: '',
                type: 'pc'
            },
            {
                name: 'lead_taken',
                title: 'Taken',
                type: 'pd'
            },
            {
                name: 'qualified',
                title: 'Qualified',
                type: 'pd'
            },
            {
                name: 'converted_to_appointment',
                title: 'Converted',
                type: 'pd'
            },
        ]
    },
    {
        name: 'Pricing',
        triggerStart: 'pricing_ordered',
        type: 'ProgressChart',
        columns: [
            {
                name: 'clients',
                title: '',
                type: 'pc'
            },            
            {
                name: 'pricing_ordered',
                title: 'Ordered',
                type: 'pd'
            },
            {
                name: 'pricing_complete',
                title: 'Complete',
                type: 'pd'
            },

        ]
    },
    {
        name: 'Valuations',
        triggerStart: 'val_ordered',
        type: 'ProgressChart',
        columns: [
            {
                name: 'clients',
                title: '',
                type: 'pc'
            },            
            {
                name: 'val_ordered',
                title: 'Ordered',
                type: 'pd'
            },
            {
                name: 'val_back',
                title: 'Back',
                type: 'pd'
            },

        ]
    },
    {
        name: 'Major Milestones',
        triggerStart: 'submitted',
        type: 'ProgressChart',
        columns: [
            {
                name: 'clients',
                title: '',
                type: 'pc'
            },            
            {
                name: 'submitted',
                title: 'Submitted',
                type: 'pd'
            },
            {
                name: 'conditional_approval',
                title: 'Conditional',
                type: 'pd'
            },
            {
                name: 'approved',
                title: 'Approved',
                type: 'pd'
            },
            {
                name: 'settlement_confirmed',
                title: 'Settled',
                type: 'pd'
            },

        ]
    },


    ]
}
},
computed:{

},
methods: {
    isChartActive(chart) {
        if(!this.activeChart || !chart)
            return false

        return (chart.name == this.activeChart.name)
    }

},
created() {
    this.activeChart = this.charts[0]
}
}

</script>

<style>
   
</style>


// WEBPACK FOOTER //
// ChartSelector.vue?73654967